import { render } from "./AdminEstateCreate.vue?vue&type=template&id=07577762&scoped=true&ts=true&lang=pug"
import script from "./AdminEstateCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEstateCreate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminEstateCreate.vue?vue&type=style&index=0&id=07577762&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07577762"]])

export default __exports__